import { ssoAPIHelper } from "services/SSOAPIHelper";
import { inMiniProgram } from "utils/WeChatUtil"

export function openLoginPage(
    {
        locale,
        redirectTo,
        isEventRegister = false,
        enableOtp = false,
        email = null,
        mobile = null,
        ticketRegisterAsMember = false,
    }
) {
    const isInMiniProgram = inMiniProgram()
    const loginUrl = ssoAPIHelper.getLoginWebUri(
        {
            locale,
            redirectTo,
            isEventRegister,
            enableOtp,
            email,
            mobile,
            ticketRegisterAsMember,
        }
    );
    if (isInMiniProgram) {
        const weChatLoginUrl = `/pages/login/login?redirect_url=${encodeURIComponent(loginUrl)}` + "&lang=" + encodeURIComponent(locale)
        window.wx.miniProgram.navigateTo({ url: weChatLoginUrl })
        return
    }
    window.location.href = loginUrl
}